var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55933 19.1074L19.0498 7.61692C22.4669 4.19984 28.0071 4.19984 31.4242 7.61692C34.8413 11.034 34.8413 16.5742 31.4242 19.9913L18.1659 33.2495C15.8879 35.5276 12.1944 35.5276 9.91635 33.2495C7.63829 30.9715 7.63829 27.278 9.91635 25L23.1746 11.7417C24.3136 10.6027 26.1604 10.6027 27.2994 11.7417C28.4384 12.8807 28.4384 14.7275 27.2994 15.8665L15.8089 27.357",
    stroke: "#011224",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.db3cb2cb039ef596ad345dde8d75dc81.svg";
export { ForwardRef as ReactComponent };